import { edmCampaign } from '@bingads-webui/edm-campaign';

export const createGoals = (payload, cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Goals['Default.AddGoals']
  .$makeCall({ payload })
  .toPromise();

export const updateGoal = (goalId, payload, cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Goals.update(goalId, payload);

export const bulkEditGoals = (payload, cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Goals['Default.UpdateGoals']
  .$makeCall({ payload })
  .toPromise();

export const createGoal = (payload, cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Goals.post(payload).toPromise();

export const getGoals = (cid, aid, params) => {
  const parameters = params || {};

  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Goals
    .get({
      filter: parameters.$filter ? { where: parameters.$filter } : {},
      count: parameters.$count || true,
      startDate: parameters.$startDate,
      endDate: parameters.$endDate,
    }).toPromise();
};
